import { RouterView } from "vue-router";

export const CooperationCompanyReport = [
  {
    path: "/report-center/download/cooperation-company-report",
    name: "cooperation-company-report",
    redirect: "/report-center/download/cooperation-company-report/list",
    component: RouterView,
    meta: { title: "供应商账款", icon: "cailiao" },
    children: [
      {
        path: "/report-center/download/cooperation-company-report/list",
        name: "cooperation-company-report-list",
        meta: { title: "供应商账款" },
        component: () =>
          import(
            /* webpackChunkName: "project-repot" */ "@/views/report-center/cooperation-company-report/list/index.vue"
          ),
      },
      {
        path: "/report-center/download/cooperation-company-report/contract-settlement-amount",
        name: "contract-settlement-amount-report-list",
        meta: { title: "合同结算金额报表" },
        component: () =>
          import(
            /* webpackChunkName: "project-repot" */ "@/views/report-center/cooperation-company-report/contractSettlementAmountReport/index.vue"
          ),
      },
      {
        path: "/report-center/download/cooperation-company-report/contract-out-amount",
        name: "contract-out-amount-report-list",
        meta: { title: "支出合同金额报表" },
        component: () =>
          import(
            /* webpackChunkName: "project-repot" */ "@/views/report-center/cooperation-company-report/contractOutAmountReport/index.vue"
          ),
      },
      {
        path: "/report-center/download/cooperation-company-report/contract-pay-apply",
        name: "contract-pay-apply-report-list",
        meta: { title: "付款申请报表" },
        component: () =>
          import(
            /* webpackChunkName: "project-repot" */ "@/views/report-center/cooperation-company-report/contractPayApplyReport/index.vue"
          ),
      },
    ],
  },
  {
    path: "/report-center/download/cooperation-company-report/client",
    name: "cooperation-company-report-client",
    meta: { title: "客户账款", icon: "cailiao" },
    component: () =>
      import(
        /* webpackChunkName: "project-repot" */ "@/views/report-center/cooperation-company-report/client/index.vue"
      ), 

  }
];
